import {
  CREATE_UPLOAD_FAQ_TOPIC_LIST_SUCCESS,
  CREATE_UPLOAD_FAQ_TOPIC_LIST_ERROR,
  CREATE_UPLOAD_FAQ_TOPIC_LIST_REQUEST
}  from "../../Types/user/Types";
import { get_upload_faq_topic_list_api } from "../../Apis/user/ApiConfig";


export const create_upload_faq_topic_list_success = (res) => {
    return {
      type: CREATE_UPLOAD_FAQ_TOPIC_LIST_SUCCESS,
      payload: res,
    };
  };
  export const create_upload_faq_topic_list_error = (error) => {
    return {
      type: CREATE_UPLOAD_FAQ_TOPIC_LIST_ERROR,
      error: error,
    };
  };
  export const create_upload_faq_topic_list_request = (res) => {
    return {
      type: CREATE_UPLOAD_FAQ_TOPIC_LIST_REQUEST,
      payload: res,
    };
  };



  export const create_upload_faq_topic_list_actionHandler = (data, Navigate) => {
    return (dispatch) => {
      dispatch(create_upload_faq_topic_list_request());
      try {
        get_upload_faq_topic_list_api()
          .then((res) => {
            if (res) {
              if (res && res?.data && res?.status === 200) {
                dispatch(create_upload_faq_topic_list_success(res?.data));
              } else {
                let data = res?.response?.data?.data;
                dispatch(create_upload_faq_topic_list_error(res));
              }
            } else {
              dispatch(create_upload_faq_topic_list_error(""));
            }
          })
          .catch((err) => {
            dispatch(create_upload_faq_topic_list_error("Something Went Wrong!!!"));
          });
      } catch (err) {
        dispatch(create_upload_faq_topic_list_error(err));
      }
    };
  };